import { NoteView } from "./note-view";
import { EntityHeader } from "../entity-header";
import { Button } from "@somethings-ui/web";
import { useHubStore } from "../use-hub-store";
import { MentorshipDetails } from "@/lib/api/mentorships";
import { usePostHogEvent } from "@/lib/posthog";
import { useCurrentUser } from "@/lib/api/user";
import { getMenteeDisplayName } from "@/lib/redacted-display";
import { useRef } from "react";

interface CreateNoteViewProps {
  mentorship: MentorshipDetails;
}

export function CreateNoteView({ mentorship }: CreateNoteViewProps) {
  const draftNoteContent = useHubStore((state) => state.draftNoteContent);
  const navigateToView = useHubStore((state) => state.navigateToView);
  const setDraftNoteContent = useHubStore((state) => state.setDraftNoteContent);
  const { dispatchEvent } = usePostHogEvent("mentor_hub", { onMount: false });
  const hasStartedTypingRef = useRef(false);

  const { data: user } = useCurrentUser();

  const handleContentChange = (content: string) => {
    if (!hasStartedTypingRef.current && content.trim().length > 0) {
      dispatchEvent("mentor_note_started");
      hasStartedTypingRef.current = true;
    }
    setDraftNoteContent(content);
  };

  const handleNext = () => {
    if (draftNoteContent?.trim()) {
      dispatchEvent("mentor_note_completed");
      navigateToView("preview-note");
    }
  };

  const recipientName = getMenteeDisplayName(mentorship.mentee);

  return (
    <div className="flex h-full flex-col bg-white">
      <EntityHeader title={`Note to ${recipientName}`} showInfo={true} />
      <div className="flex-1 overflow-y-auto p-6">
        <NoteView
          content={draftNoteContent || ""}
          editMode={true}
          placeholder="Start writing your note..."
          maxLength={620}
          onContentChange={handleContentChange}
          creatorAvatarUrl={user?.profile_picture_url ?? undefined}
          creatorName={user?.name ?? undefined}
        />
      </div>

      <div className="border-t border-zinc-300 bg-white p-4">
        <Button
          onClick={handleNext}
          disabled={!draftNoteContent?.trim()}
          variant="primary"
          shape="pill"
          className="w-full"
        >
          Next
        </Button>
      </div>
    </div>
  );
}
